// src/views/Billing/Invoices/InvoiceModal.jsx
import React, { useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function InvoiceViewModal({ show, onHide }) {
  // Fallback to Redux if prop not given
  const pdfFromStore = useSelector((s) => s.activityReducer?.invoiceBase64);
  const b64 = pdfFromStore || "";

  // Build a data URL for the iframe
  const pdfSrc = useMemo(() => {
    if (!b64) return "";
    return `data:application/pdf;base64,${b64.message}`;
  }, [b64]);

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Invoice Preview</Modal.Title>
      </Modal.Header>

      {/* Remove all form content; only iframe */}
      <Modal.Body style={{ padding: 0 }}>
        {pdfSrc ? (
          <iframe
            title="invoice-pdf"
            src={pdfSrc}
            style={{ width: "100%", height: "80vh", border: "none" }}
          />
        ) : (
          <div className="p-4">No PDF available.</div>
        )}
      </Modal.Body>
    </Modal>
  );
}
